import PlayerBasicModel from "../../../Football/Models/Player/PlayerBasicModel";
import TeamBasicModel from "../../../Football/Models/Team/TeamBasicModel";

export default class PotmResultsModel {
  public teamId: string = null;
  public teamModel: TeamBasicModel | null = null;
  public playerId: string = null;
  public playerModel: PlayerBasicModel | null = null;
  public votes: number = null;
  public winner: boolean = null;
}
